<template>
    <div class="min-h-screen bg-gray-50">
        <!-- Hero Section -->
        <div class="relative h-64 md:h-80 w-full flex items-center justify-center overflow-hidden">
            <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80"
                alt="Refund Hero" class="absolute inset-0 w-full h-full object-cover object-center opacity-80" />
            <div class="relative z-10 flex flex-col items-center justify-center w-full h-full">
                <span class="uppercase tracking-widest text-white text-xs md:text-sm mb-2">Our Policy</span>
                <h1 class="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg mb-2 text-center">Refund Policy
                </h1>
                <p class="text-white text-base md:text-lg font-medium drop-shadow text-center">How we handle refunds and
                    eligibility</p>
            </div>
            <div class="absolute inset-0 bg-gradient-to-b from-green-900/60 to-transparent"></div>
        </div>

        <!-- Main Content -->
        <div class="max-w-3xl mx-auto -mt-16 pb-16 px-4">
            <div class="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative z-20">
                <section class="mb-8">
                    <h2 class="text-xl font-semibold text-gray-900 mb-4">OptimaAI offers refunds under certain
                        conditions. Please review our policy below.</h2>
                </section>
                <div class="divide-y divide-green-50">
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-2 flex items-center"><span class="mr-2">1.</span>
                            Refund Eligibility</h3>
                        <ul class="list-disc pl-6 text-gray-700">
                            <li>Technical issues preventing service usage</li>
                            <li>Service unavailability for more than 24 hours</li>
                            <li>Billing errors or duplicate charges</li>
                        </ul>
                    </section>
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-2 flex items-center"><span class="mr-2">2.</span>
                            Non-Refundable Items</h3>
                        <ul class="list-disc pl-6 text-gray-700">
                            <li>Partial subscription periods</li>
                            <li>Usage of premium features</li>
                            <li>Custom development services</li>
                            <li>Training and onboarding services</li>
                        </ul>
                    </section>
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-black mb-2 flex items-center"><span class="mr-2">3.</span>
                            Refund Process</h3>
                        <ol class="list-decimal pl-6 text-gray-700">
                            <li>Contact our support team within 7 days of the charge</li>
                            <li>Provide your account details and reason for refund</li>
                            <li>Allow 5-7 business days for review</li>
                            <li>If approved, refund will be processed to original payment method</li>
                        </ol>
                    </section>
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-2 flex items-center"><span class="mr-2">4.</span>
                            Refund Timeline</h3>
                        <ul class="list-disc pl-6 text-gray-700">
                            <li>Review period: 5-7 business days</li>
                            <li>Processing time: 3-5 business days</li>
                            <li>Bank processing: 2-7 business days</li>
                        </ul>
                    </section>
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-2 flex items-center"><span class="mr-2">5.</span>
                            Contact Us</h3>
                        <p class="text-gray-700">For refund inquiries, please contact:</p>
                        <p class="text-blue-700 font-semibold">Email: support@optimaai.app</p>
                        <p class="text-blue-700 font-semibold">Phone: +1 (800) 888-8888</p>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RefundPolicy'
}
</script>